import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
// import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import { keyWord } from "../../http/http-calls";
import { showToast } from "../../helper-methods";

const ModerationSettingModal = ({ isOpen, toggle, id, keyWords }) => {
  const [chips, setChips] = useState([]);
  const [value, setValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  const _closeModal = () => {
    toggle();
    setValue("");
  };

  useEffect(() => {
    const updatedValue = keyWords.map((keyWord) => createOption(keyWord));
    setValue(updatedValue);
  }, [keyWords]);

  const handleChange = (value, actionMeta) => {
    // console.group("Value Changed");
    // console.log(value);
    // console.log(`action: ${actionMeta.action}`);
    // console.groupEnd();
    setValue(value);

    let finalValue = value.map((item) => {
      return item.value;
    });
    let newValue = finalValue.toString();
    // console.log("888", newValue);

    let newPermissions = [...chips];
    let finalState = [];
    if (value) {
      let test = newPermissions.filter((each) => newValue === each);
      // console.log("testing", test);
      finalState = [...test];
    }
    setChips(finalState);
  };

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        // console.group("Value Added");
        // console.log(value);
        // console.groupEnd();
        setInputValue("");
        setValue([...value, createOption(inputValue)]);
        event.preventDefault();
        console.log("56", inputValue);

        let newPermissions = [...chips];
        let finalState = [];
        if (inputValue) {
          newPermissions.push(inputValue);
          finalState = [...newPermissions];
          console.log(finalState);
        }
        setChips(finalState);

        break;
      default:
        return;
    }
  };

  const _submitHandler = async () => {
    // console.log("finalValue", chips);

    if (chips.length) {
      try {
        const res = await keyWord({ keyWords: chips }, id);
        console.log("badKeyword", res);
        // fetchAll();
      } catch (error) {
        // console.log(error);
        showToast(error.reason, "error");
      }
    }
    _closeModal();
  };

  // console.log("chips >>", value);

  return (
    <Modal isOpen={isOpen} toggle={() => _closeModal()} scrollable centered>
      <ModalHeader toggle={() => _closeModal()}>Settings</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Label>Banned Keywords</Label>

              <CreatableSelect
                // components={components}
                inputValue={inputValue}
                isClearable
                isMulti
                menuIsOpen={false}
                onChange={handleChange}
                onInputChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder="Type something and press enter..."
                value={value}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="closeBtn" onClick={() => _closeModal()}>
          Cancel
        </Button>
        <Button color="primary" onClick={() => _submitHandler()}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModerationSettingModal;
